import * as React from "react";
import moment from "moment";
import { ViewOfferPWA, CountOfferView } from "@njoy/controller";
import DiscoverOfferCard from "./DiscoverOfferCards";
import * as ROUTES from "../../constants/routes";

export const OfferCountdownCard = ({ offer, ...props }: { offer: any }) => {
  const endDate = moment(offer.endDate);
  const [countdown, setCountdown] = React.useState("");
  const now = moment();
  const daysLeft = endDate.diff(now, "days");
  const highlight = daysLeft <= 7 && daysLeft >= 0;

  React.useEffect(() => {
    if (!highlight || endDate.isBefore(moment())) {
      setCountdown("");
      return;
    }
    const updateCountdown = () => {
      const now = moment();
      const duration = moment.duration(endDate.diff(now));
      if (duration.asMilliseconds() <= 0) {
        setCountdown("Expired");
      } else {
        const days = Math.floor(duration.asDays());
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();
        setCountdown(`${days}d ${hours}h ${minutes}m ${seconds}s left`);
      }
    };
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [offer.endDate, highlight, endDate]);

  let status = "Available now!";
  if (highlight) {
    if (endDate.isBefore(now)) {
      status = "Expired";
    } else {
      status = countdown || `${daysLeft} days left`;
    }
  }

  return (
    <ViewOfferPWA offerId={offer.id} key={offer.id}>
      {(data) => {
        // if (!data.offer) {
        //   return (
        //     <p className="text-[#9fafb5] flex justify-center items-center">loading...</p>
        //   );
        // }

        return (
          <CountOfferView>
            {({ countOfferView }) => (
              <DiscoverOfferCard
                offerType={data?.offer?.offerType}
                imgSrc={offer.bannerUrl ?? ""}
                heading={offer.title}
                icon={offer.createdBy.admin?.merchantProfile?.logoUrl ?? ""}
                label={offer.createdBy.admin?.merchantProfile?.companyName ?? ""}
                status={status}
                linkToOffer={`${ROUTES.VIEW_OFFER}/${offer.id}`}
                linkToMerchant={`${ROUTES.VIEW_MERCHANT}/${offer.createdBy.id}`}
                highlight={highlight}
                countOfferView={countOfferView}
                offerId={data?.offer?.id}
              />
            )}
          </CountOfferView>
        );
      }}
    </ViewOfferPWA>
  );
};
